export const AVERAGE_BALANCE_SECTION_TITLE =
  'Середньоденні залишки на поточних і депозитних рахунках';
export const AVERAGE_BALANCE_TABLE_ARIA_LABEL =
  'Середньоденні залишки на поточних і депозитних рахунках';
export const AVERAGE_BALANCE_TABLE_BASE_HEADERS = ['Банк', 'Валюта'] as const;
export const AVERAGE_BALANCE_MONTH_AMOUNT_FIELDS = [
  'firstMonthAmount',
  'secondMonthAmount',
  'thirdMonthAmount',
] as const;
export const AVERAGE_BALANCE_MONTHLY_TABLE_COLUMN_WIDTHS = ['48%', '22%', '30%'] as const;
export const AVERAGE_BALANCE_QUARTERLY_TABLE_COLUMN_WIDTHS = [
  '30%',
  '15%',
  '18.33%',
  '18.33%',
  '18.34%',
] as const;

export const BANK_INCOME_SECTION_TITLE =
  'Інформація про надходження грошових коштів в інших банках';
export const BANK_INCOME_TABLE_ARIA_LABEL = 'Надходження грошових коштів в інших банках';
export const BANK_INCOME_TABLE_HEADERS = [
  'Банк',
  'Валюта',
  'Всього, тис. од.',
  'В тому числі виручка від реалізації, тис. од.',
] as const;
export const BANK_INCOME_TABLE_COLUMN_WIDTHS = ['30%', '18%', '22%', '30%'] as const;
